import * as React from "react";
const SvgCreateFilter24Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 25,
        height: 25,
        fill: "black",
        viewBox: "0 0 25 25"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M24.12 7.033a6.3 6.3 0 0 1-9.242 5.572l-1.192 1.59v7.852L8.279 24.48V14.195L.62 3.983h11.686a6.3 6.3 0 0 1 11.814 3.05ZM11.644 5.785h-7.42l5.857 7.81v8.097l1.803-.81v-7.288l1.538-2.05a6.282 6.282 0 0 1-1.902-4.511c0-.427.043-.845.124-1.248Zm6.876-2.252v2.8h2.8v1.4h-2.8v2.8h-1.4v-2.8h-2.8v-1.4h2.8v-2.8h1.4Z",
      clipRule: "evenodd"
    }),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M24.12 7.033a6.3 6.3 0 0 1-9.242 5.572l-1.192 1.59v7.852L8.279 24.48V14.195L.62 3.983h11.686a6.3 6.3 0 0 1 11.814 3.05ZM11.644 5.785h-7.42l5.857 7.81v8.097l1.803-.81v-7.288l1.538-2.05a6.282 6.282 0 0 1-1.902-4.511c0-.427.043-.845.124-1.248Zm6.876-2.252v2.8h2.8v1.4h-2.8v2.8h-1.4v-2.8h-2.8v-1.4h2.8v-2.8h1.4Z",
      clipRule: "evenodd"
    })
  );
export default SvgCreateFilter24Px;
